/* eslint-disable react/prop-types */
import React, { useState, useEffect, useMemo } from "react";
import {
  IconButton,
  TextField,
  Button,
  Card,
  Alert,
  Box,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Tooltip,
  Snackbar,
} from "@mui/material";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import { Delete, Edit, Cancel, Check } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import Footer from "components/Footer";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_VI } from "material-react-table/locales/vi";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import CRUDloaihinh from "./CRUDloaihinh";
import { useMaterialUIController, setHomePage } from "context";
import { darken } from "@mui/material";

const LoaiHinh = () => {
  const [controller, dispatch] = useMaterialUIController();
  useEffect(() => {
    setHomePage(dispatch, false);
  }, []);
  const [modalOpen, setModalOpen] = useState(false);
  const [action, setAction] = useState("Edit");
  const [tableData, setTableData] = useState({});
  const [dataRow, setDataRow] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const axiosPrivateInstance = useAxiosPrivate();

  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [title, setTitle] = useState(0);
  const [alert, setAlert] = useState({
    alert: false,
    message: null,
    type: null,
  });

  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);

  const handleDelete = async () => {
    try {
      const response = await axiosPrivateInstance.delete(
        "loaihinh/" + selectedRow.id
      );
      // Remove the selected row from the data
      setTableData((prevData) =>
        prevData.filter((row) => row.id !== selectedRow.id)
      );
      // setTableData([...tableData]);
      setAlert({
        alert: true,
        message: "Xoá bản ghi thành công!",
        type: "success",
      });
    } catch (error) {
      const ms = error.response.data;
      setAlert({ alert: true, message: ms.error, type: "warning" });
    }
    // Close the delete confirmation dialog
    setDeleteConfirmationOpen(false);
  };

  const handleOpenDeleteConfirmation = (row) => {
    // Set the selected row and open the delete confirmation dialog
    setSelectedRow(row);
    setDeleteConfirmationOpen(true);
  };

  const handleCloseDeleteConfirmation = () => {
    // Close the delete confirmation dialog
    setDeleteConfirmationOpen(false);
  };

  const handleSave = async (values) => {
    try {
      if (action == "Edit") {
        const response = await axiosPrivateInstance.put(
          "loaihinh/" + values.id,
          { ...values },
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        tableData[values.rowIndex] = response.data;
        setAlert({
          alert: true,
          message: "Cập nhật thành công!",
          type: "success",
        });
      } else {
        const response = await axiosPrivateInstance.post(
          "loaihinh",
          { ...values },
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        tableData.unshift(response.data);
        setAlert({
          alert: true,
          message: "Thêm mới thành công!",
          type: "success",
        });
      }
      setTableData([...tableData]);
      setValidationErrors({});
      setModalOpen(false);
    } catch (error) {
      let validErrors = {};
      let data = error.response.data;
      if (error && error.response) {
        if (Array.isArray(data)) {
          let value = "";
          value = data?.join(";");
          validErrors = { ...validErrors, another: value };
        } else {
          Object.entries(data).forEach(([key, value]) => {
            let val = value;
            if (Array.isArray(value)) {
              value.map((item) => {
                val += item;
              });
            } else {
              val = value;
            }
            validErrors = { ...validErrors, [key]: val };
          });
        }
      } else {
        validErrors = { ...validErrors, error: error };
      }
      setValidationErrors(validErrors);
      return;
    }
  };

  const handelEditClick = async (row) => {
    const id = row.getValue("id");
    try {
      const response = await axiosPrivateInstance.get("loaihinh/" + id);
      setDataRow({ ...response.data, rowIndex: row.index });
    } catch (error) {
      setIsError(true);
      return;
    }
    setAction("Edit");
    setTitle("Chỉnh sửa loại hình");
    setValidationErrors({});
    setModalOpen(true);
  };
  useEffect(() => {
    const fetchData = async () => {
      if (!tableData.length) {
        setIsLoading(true);
      } else {
        setIsRefetching(true);
      }
      try {
        const response = await axiosPrivateInstance.get("loaihinh");
        setTableData(response.data);
      } catch (error) {
        setIsError(true);
        return;
      }
      setIsError(false);
      setIsLoading(false);
      setIsRefetching(false);
    };
    fetchData();
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "Id",
        enableEditing: false,
        enableHiding: false,
        enableColumnActions: false,
        size: 50,
      },
      {
        accessorKey: "ma",
        header: "Mã loại hình",
      },
      {
        accessorKey: "ten",
        header: "Tên loại hình",
      },
      {
        accessorKey: "ghichu",
        header: "Mô tả",
      },
      {
        accessorKey: "sothutu",
        header: "Số thứ tự",
      },
    ],
    []
  );

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ alert: false, message: null, type: null });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Box>
          {alert.alert && (
            <Snackbar
              autoHideDuration={3000}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              open={alert.alert}
              onClose={handleCloseAlert}
            >
              <Alert onClose={handleCloseAlert} severity={alert.type}>
                {alert.message}
              </Alert>
            </Snackbar>
          )}
          <MaterialReactTable
            muiToolbarAlertBannerProps={
              isError
                ? {
                    color: "error",
                    children: "Lỗi khi lấy dữ liệu",
                  }
                : undefined
            }
            columns={columns}
            data={tableData}
            // editingMode="modal" //default
            enableColumnOrdering
            enableEditing
            localization={MRT_Localization_VI}
            positionActionsColumn="last"
            renderRowActions={({ row, table }) => (
              <Box sx={{ display: "flex" }}>
                <IconButton color="info" onClick={() => handelEditClick(row)}>
                  <Edit />
                </IconButton>
                <Tooltip arrow placement="right" title="Xoá">
                  <IconButton
                    color="error"
                    onClick={() => {
                      let _data = {};
                      row
                        .getAllCells()
                        .filter(
                          (cell) =>
                            cell.column.columnDef.columnDefType === "data"
                        )
                        .map((cell) => {
                          _data[cell.column.id] = row.getValue(cell.column.id);
                        });
                      handleOpenDeleteConfirmation(_data);
                    }}
                  >
                    <Delete />
                  </IconButton>
                </Tooltip>
              </Box>
            )}
            renderTopToolbarCustomActions={() => (
              <Stack spacing={2} direction="row" color="white">
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  sx={{ color: "#ffffff" }}
                  onClick={() => {
                    setAction("New");
                    setTitle("Thêm mới loại hình");
                    setDataRow({});
                    setModalOpen(true);
                    setValidationErrors({});
                  }}
                >
                  Tạo mới
                </Button>
              </Stack>
            )}
            initialState={{
              columnVisibility: {
                id: false,
              },
            }}
            displayColumnDefOptions={{
              "mrt-row-actions": {
                muiTableHeadCellProps: {
                  align: "center",
                },
                muiTableBodyCellProps: {
                  align: "center",
                },
                size: 120,
              },
            }}
            state={{
              // columnFilters,
              // globalFilter,
              isLoading,
              // pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              // sorting,
            }}
            muiTablePaperProps={{
              elevation: 0,
              sx: {
                borderRadius: "0",
                border: "1px solid rgb(211 225 245)",
                backgroundColor: "#fff",
              },
            }}
            muiTableBodyProps={{
              sx: (theme) => ({
                "& tr:nth-of-type(odd)": {
                  backgroundColor: darken(
                    theme.palette.background.default,
                    0.1
                  ),
                },
              }),
            }}
          />
          <CRUDloaihinh
            data={dataRow}
            open={modalOpen}
            title={title}
            onClose={() => {
              setModalOpen(false);
              setValidationErrors({});
            }}
            onSubmit={handleSave}
            validationErrors={validationErrors}
            action={action}
          />
          {/* Delete Confirmation Dialog */}
          <Dialog
            open={deleteConfirmationOpen}
            onClose={handleCloseDeleteConfirmation}
          >
            <DialogTitle>Xoá bảng ghi</DialogTitle>
            <DialogContent>
              Bạn muốn xoá tên: {selectedRow?.ten} này không?
            </DialogContent>
            <DialogActions>
              <Button
                color="secondary"
                type="button"
                variant="contained"
                startIcon={<Cancel />}
                size="small"
                onClick={handleCloseDeleteConfirmation}
                sx={{ color: "#ffffff", float: "right", mr: 1 }}
              >
                Hủy
              </Button>
              <MDButton
                color="primary"
                onClick={handleDelete}
                variant="contained"
                startIcon={<Check />}
                size="small"
                sx={{ float: "right", mr: 1 }}
              >
                Đồng ý
              </MDButton>
            </DialogActions>
          </Dialog>
        </Box>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};
export default LoaiHinh;
